import template from './about-object.jade';

export default () => {
    return {
        template,
        scope: {},
        bindToController: {
            category: '@',
            categoryInfo: '=',
            ad: '=',
            form: '=',
        },
        controller() {},
        controllerAs: 'aboutObjectCtrl',
        replace: true,
    };
};
